import $ from "jquery";

if (!window.jQuery) {
  window.jQuery = $;
  window.$ = $;
}
